export const MONITORING_CAPABILITY_OFF = 'off';
export const MONITORING_CAPABILITY_INBOUND = 'inbound';
export const MONITORING_CAPABILITY_OUTBOUND = 'outbound';

export const isConnectorMonitoringSupported = (manifest) => {
  const monitoringCapability = manifest?.monitoringCapability || MONITORING_CAPABILITY_OFF;
  const inbound = manifest?.functionScope?.invokeDirection?.inbound === true;
  const outbound = manifest?.functionScope?.invokeDirection?.outbound === true;

  return (
    (monitoringCapability === MONITORING_CAPABILITY_INBOUND && inbound && !outbound) ||
    (monitoringCapability === MONITORING_CAPABILITY_OUTBOUND && outbound && !inbound)
  );
};
